<template>
  <div class="quote wrap" ref="wrap">
    <header class="header">
      <h2>业务咨询</h2>
      <span>全国业务，快速受理</span>
    </header>
    <article class="form">
      <el-button type="primary" class="quick" @click="handleQuick" v-if="dialogData.isShowQuick">快速报价</el-button>
      <el-row>
        <el-form :inline="true" :model="form" class="demo-form-inline" :rules="rules" label-width="80px" ref="ruleForm">
          <el-col :span="!tradeOptions.length && alias !== 'governments' ? 24 : 12" v-if="showService">
            <el-form-item label="服务类型" prop="service">
              <el-select v-model="form.service" placeholder="请选择您需要的服务类型*" @change="serviceChange" style="width: 100%;">
                <el-option v-for="item in serviceOptions" :key="item.id" :label="item.quoteAlias || item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="tradeOptions.length || alias === 'governments'">
            <el-form-item label="产品类别" prop="productId" v-if="tradeOptions.length">
              <el-select v-model="form.productId" placeholder="请选择您的产品类别*" @change="tradeChange">
                <el-option v-for="item in tradeOptions" :key="item.productId" :label="item.productName"
                  :value="item.productId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="目的国" prop="destCountry" v-if="alias === 'governments'">
              <el-input v-model="form.destCountry" placeholder="请输入目的国*" maxlength="50"></el-input>
            </el-form-item>
            <!-- <el-form-item label=" " v-if="!tradeOptions.length && alias !== 'governments'">
              <div>&nbsp;</div>
            </el-form-item> -->
          </el-col>
          <!-- <el-col :span="12"></el-col> -->
          <el-col :span="12">
            <el-form-item label="企业名称" prop="company">
              <el-input v-model="form.company" placeholder="请输入企业名称*" maxlength="200"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在地区" prop="provice">
              <el-select v-model="form.provice" placeholder="请选择所在省份或地区*" filterable style="width: 100%;">
                <el-option v-for="item in provice" :key="item.orgName" :label="item.orgName" :value="item.orgName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="姓名" prop="customer">
              <el-input v-model="form.customer" placeholder="请输入您的姓名" maxlength="25"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" class='is-required' prop="phone">
              <el-input v-model="form.phone" placeholder="请输入您的手机号" maxlength="50" ref="phone"
                suffix-icon="el-icon-mobile-phone" @change='handleInputPhone'
                :disabled="isLogin && disablePhone"></el-input>
              <p class="tips">自动注册会员，在线查看咨询进度</p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label=" " prop="mail">
              <el-input v-model="form.email" placeholder="请输入您的电子邮箱" maxlength="80" ref="mail"
                suffix-icon="el-icon-message" @change='handleInputEmail' :disabled="isLogin && disableMail">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="需求描述" prop="content" class="content">
              <el-input type="textarea" v-model="form.content" resize="none" maxlength="1000"
                :placeholder="productExplain || '请描述您的送测产品，若有明确的测试项目名称或测试标准号请提供*'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label=" " class="content">
              <el-upload class="upload-demo"
                action="https://gateuat.sgsonline.com.cn/ticCenter/business/api.v0.platform/fileUpload/uploadOss"
                multiple :limit="3" :on-success="uploadSuccess" :on-remove="uploadRemove" :before-upload="uploadBefore">
                <el-button size="small" type="primary">上传文件</el-button>
                <div slot="tip" class="el-upload__tip">可上传图片、文档等文件，且不超过20M</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="contact_approve">
              <el-checkbox v-model="dialogReg.approve">
                <span style="color: #333333;">
                  <template v-if='!isLogin'>提交后自动注册会员，获取后续信息，</template>
                  我已阅读并同意
                  <template v-if='!isLogin'><a @click='dialogReg.visible = true'>注册条款</a>及</template>
                  <a href="https://www.sgsgroup.com.cn/zh-cn/privacy-at-sgs" target="_blank">隐私政策</a>
                </span>
              </el-checkbox>
            </div>
          </el-col>
          <el-col :span="24" class="submit">
            <el-button @click="handleSubmit" type="primary" :disabled="disableSubmit && showService"
              :loading="submitLoading">提交</el-button>
          </el-col>
        </el-form>
      </el-row>
    </article>
    <!-- oiq引导 -->
    <div class="dialog" v-if="dialogData.visible">
      <div class="shade"></div>
      <div class="content">
        <img :src="dialogData.jumpImg && dialogData.jumpImg.pc ? dialogData.jumpImg.pc : dialogData.defaultImg" alt=""
          class="bg">
        <img :src="dialogData.closeImg" alt="" class="close" @click="handleCloseOIQ">
        <el-button type="primary" class="btn" @click="handleQuick">开始快速报价 ({{ dialogData.num }}s)</el-button>
      </div>
    </div>
    <!-- 注册协议 -->
    <register-terms v-if="dialogReg.visible" @setTipsVisible="setTipsVisible"></register-terms>
    <login-verify-code ref="loginVerifyCode" :env="env" :captcha-app-id="captchaAppId" v-model="dialogCode.visible"
      :captcha-show="!!form.phone" :number="form.phone || form.email" :data="pageInfo"
      :handle-submit="handleSubmitService" :verify-params="verifyParams" />
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { qryByAlias, qryProduct, qryCity, createTicketByPhone } from "../../request/portal";
import RegisterTerms from "../loginMerge/RegisterTerms";
import LoginVerifyCode from "../loginVerifyCode/index.vue";
import { host } from "src/config";

export default {
  name: 'PortalQuote',
  components: {
    RegisterTerms,
    LoginVerifyCode
  },
  props: {
    env: {
      type: String,
      default: "local",
    },
    userInfo: {
      type: Object,
      default: () => { },
    },
    defaultForm: {
      type: Object,
      default: null
    },
    captchaAppId: {
      type: String,
      default: ''
    },
    memberUrl: {
      type: String,
      default: ''
    },
    showService: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const validatorUserPhone = (rule, value, callback) => {
      const reg = /^1[2|3|4|5|6|7|8|9][0-9]\d{8}$/
      if (!value) {
        return callback(new Error('请输入手机'));
      } else if (!reg.test(value)) {
        return callback(new Error('请输入正确的手机号码'));
      } else {
        return callback()
      }
    }
    const validatorEmail = (rule, value, callback) => {
      const reg = /^[a-zA-Z0-9_.-]+@\w+([-.][A-Za-z0-9]+)*\.\w+([-.][A-Za-z0-9]+)*$/
      if (!value) {
        return callback(new Error('请输入邮箱'));
      } else if (!reg.test(value)) {
        return callback(new Error('请输入正确的邮箱'));
      } else {
        return callback()
      }
    }
    // 手机和邮箱的联合认证
    const validatorPhone = (rule, value, callback) => {
      const phoneRef = this.$refs.phone
      const phoneValue = phoneRef.$options.propsData.value
      const mailRef = this.$refs.mail
      const mailValue = mailRef.$options.propsData.value
      if (!phoneValue && !mailValue) {
        return callback(new Error('*请填写联系方式，手机号与邮箱至少填写一项'));
      } else if (phoneValue && !validatorUserPhone(rule, phoneValue, callback)) {
        return callback(new Error('*请输入正确的手机号码'));
      } else {
        return callback()
      }
    }

    const validatorMail = (rule, value, callback) => {
      const phoneRef = this.$refs.phone
      const phoneValue = phoneRef.$options.propsData.value
      const mailRef = this.$refs.mail
      const mailValue = mailRef.$options.propsData.value
      if (!phoneValue && !mailValue) {
        return callback(new Error('*请填写联系方式，手机号与邮箱至少填写一项'));
      } else if (mailValue && !validatorEmail(rule, mailValue, callback)) {
        return callback(new Error('*请输入正确的邮箱'));
      } else {
        return callback()
      }
    }
    return {
      host: host(this.env),
      isLogin: false, // 登陆状态
      disablePhone: false, // 禁用手机号
      disableMail: false, // 禁用邮箱地址
      disableSubmit: true,
      alias: '', // 别名，用来判断是否是清关认证
      productExplain: '', // 测试要求的默认占位符
      /*
        提交咨询表单
      */
      form: {
        type: '业务咨询',
        trade: '',
        tradeName: '其他',
        service: '',
        serviceName: '其他',
        productId: '',
        productName: '',
        company: '',
        provice: '',
        content: '',
        customer: '',
        email: '',
        phone: '',
        imageCode: '',
        frontUrl: window.location.href,
        destCountry: '',
        verifyCode: '',
        files: [],
        formIndex: 0,
        osType: 'pc',
        regSource: '',
        regMode: 'USER_REG',
        regFrom: window.location.href
      },
      /* 表单认证 */
      rules: {
        productId: [{ required: true, message: '*请选择您需要的产品类别' }],
        service: [{ required: true, message: '*请选择您的服务类型' }],
        company: [{ required: true, message: '*请输入企业名称' }],
        provice: [{ required: true, message: '*请选择所在省份或地区' }],
        content: [{ required: true, message: '*请描述您的需求' }],
        customer: [{ required: true, message: '*请输入您的姓名' }],
        destCountry: [{ required: true, message: '*请输入目的国' }],
        phone: [
          {
            required: false,
            message: '*请填写联系方式，手机号与邮箱至少填写一项',
            trigger: 'change',
          },
          {
            trigger: 'change',
            validator: validatorPhone,
          }
        ],
        mail: [
          {
            required: false,
            message: '*请填写联系方式，手机号与邮箱至少填写一项',
            trigger: 'change',
          },
          {
            trigger: 'change',
            validator: validatorMail,
          }
        ]
      },
      tradeOptions: [], // 服务列表
      serviceOptions: [], // 行业列表
      provice: [], // 城市列表
      /*
        oiq引导相关
      */
      dialogData: {
        defaultImg: require('../../assets/images/quote/oiq_dialog.png'),
        closeImg: require('../../assets/images/quote/closeDialog.png'),
        jumpImg: {},
        jumpUrl: {},
        num: 2,
        timer: null,
        visible: false,
        isShowQuick: false
      },
      /* 验证码相关 */
      dialogCode: {
        visible: false,
        seconds: 59,
        timer: null
      },
      /* 注册条款相关 */
      dialogReg: {
        visible: false,
        approve: false,
        // contact_approve_show: true // 是否显示注册条款触发按钮
      },
      // 弹窗文案，融合手机以及邮箱
      pageInfo: {
        title: '验证手机号',
        sendModel: '已发送到手机号：+86',
        prepend: '手机验证码'
      },
      submitBtnLoading: false,
      sendCodeBtnLoading: false,
      verifyParams: {
        projectName: 'TIC_TEMPLATE',
        verifyType: 2
      },
      submitLoading: false
    }
  },
  watch: {
    defaultForm: {
      handler(val) {
        if (val) {
          this.form = Object.assign(this.form, val)
        }
      },
      immediate: true
    },
    userInfo: {
      handler(val) {
        if (val) {
          this.form.customer = val.userNick;
          this.form.phone = val.userPhone;
          this.form.email = val.userEmail;
          // this.form.provice = val.provice
          if (val.userId) {
            this.isLogin = true;
            this.contact_approve_show = false;
          }
          // 登录后如果邮箱和手机有值，禁用输入框
          if (val.userPhone) this.disablePhone = true
          if (val.userEmail) this.disableMail = true
        }
      },
      immediate: true,
    },
    form: {
      handler(val) {
        let status = true
        const list = ['company', 'provice', 'content', 'customer']
        // 页面必填的字段过滤，如果有未填写的返回false
        Object.keys(val).forEach((v) => {
          list.forEach((v2) => {
            if (v === v2 && val[v] === '') status = false
          })
        })
        // 是否选择了清关认证
        if (this.alias === 'governments' && val['destCountry'] === '') status = false
        // 手机号或邮箱必填且正则通过
        if (!this.form.phone && !this.form.email) status = false
        // 服务为空的判断
        if (this.serviceOptions.length && this.form.service === '') status = false
        // 行业为空的判断
        if (this.tradeOptions.length && this.form.productId === '') status = false
        // 协议是否勾选
        //  if(!this.dialogReg.approve) status = false
        this.disableSubmit = !status
      },
      immediate: true,
      deep: true
    },
  },
  mounted() {
    if (this.showService) {
      qryByAlias({ alias: 'service' }, this.host.nodeUrl).then(res => {
        this.serviceOptions = res.data.items || []
        this.serviceOptions.push({
          id: 0,
          name: '其他'
        })
      })
    }
    qryCity({}, this.host.nodeUrl).then(res => {
      for (var i = 0; i < res.data.length; i++) {
        res.data[i].citys = null
      }
      this.provice = res.data || []
    })
    this.form.frontUrl = this.$route.query.frontUrl || location.href
  },
  methods: {
    // 选择服务类目
    serviceChange() {
      // 通过选中的服务id，获取对象实例
      const { productExplain, id: serviceId, name, alias } = this.serviceOptions.find(v => v.id === this.form.service)
      this.productExplain = productExplain
      this.form.serviceName = name
      this.alias = alias
      this.dialogData.isShowQuick = false
      // 清空行业选项
      this.form.trade = ''
      this.form.tradeName = ''
      this.form.productId = ''
      this.form.productName = ''
      this.tradeOptions = []
      qryProduct({ serviceId }, this.host.nodeUrl).then(res => {
        this.tradeOptions = res.data.items || []
        if (this.tradeOptions.length) {
          this.tradeOptions.push({
            industryId: 0,
            industryName: '其他',
            productId: 0,
            productName: '其他'
          })
          this.form.formIndex = this.form.formIndex + 1
        }
      })
    },
    // 选择行业类目
    tradeChange() {
      // 通过选中的行业id，获取对象实例
      const { industryId, industryName, productId, productName, jumpImg, jumpUrl, jumpType } = this.tradeOptions.find(v => v.productId === this.form.productId)
      this.form.trade = industryId
      this.form.tradeName = industryName
      this.form.productId = productId
      this.form.productName = productName
      this.dialogData.jumpImg = jumpImg
      this.dialogData.jumpUrl = jumpUrl
      if (jumpType) {
        this.dialogData.visible = true
        this.dialogStart()
      }
      this.dialogData.isShowQuick = false
    },
    // oiq定时器开始
    dialogStart() {
      this.dialogData.timer = setInterval(() => {
        if (this.dialogData.num) {
          this.dialogData.num--
        } else {
          this.handleCloseOIQ()
          window.open(this.memberUrl + '/questionnaire/step1')
        }
      }, 1000);
    },
    // oiq定时器结束
    dialogEnd() {
      clearInterval(this.dialogData.timer);
      this.dialogData.timer = null
      this.dialogData.num = 2
    },
    // oiq弹窗关闭
    handleCloseOIQ() {
      this.dialogData.visible = false
      this.dialogData.isShowQuick = true
      this.dialogEnd()
    },
    // 点击快速开始报价
    handleQuick() {
      this.handleCloseOIQ()
      window.open(this.memberUrl + '/questionnaire/step1')
    },
    handleInputPhone() {
      this.$refs.ruleForm.validate((valid) => { })
    },
    handleInputEmail() {
      this.$refs.ruleForm.validate((valid) => { })
    },
    // 提交留言表单
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 隐私条款勾选状态
          if (this.dialogReg.approve) {
            if (!this.form.phone && this.form.email) {
              this.pageInfo = {
                title: '验证邮箱',
                sendModel: '已发送到邮箱',
                prepend: '邮箱验证码'
              }
            } else {
              this.pageInfo = {
                title: '验证手机号',
                sendModel: '已发送到手机号：+86',
                prepend: '手机验证码'
              }
            }
            // 登录直接提交
            if (this.isLogin) {
              this.submitLoading = true
              createTicketByPhone(this.form, this.host.nodeUrl).then(res => {
                this.submitResult(res)
              }).catch(e => {
                this.submitLoading = false
              })
            } else {
              this.dialogCode.visible = true
            }
          } else {
            this.$message.error('请先阅读隐私政策并选择是否同意')
          }
        }
      })
    },
    // 提交数据到服务端
    handleSubmitService(loginRef) {
      this.form.verifyCode = loginRef.verifyCode
      this.submitBtnLoading = true
      this.form.verifyMode = this.form.phone ? 'phone' : 'email'
      if (this.form.verifyCode) {
        loginRef.loading = true
        createTicketByPhone(this.form, this.host.nodeUrl).then(res => {
          loginRef.loading = false
          this.submitResult(res)
        }).catch(e => {
          loginRef.loading = false
          this.submitBtnLoading = false
        })
      } else {
        this.$message.error('请输入验证码')
        this.submitBtnLoading = false
      }
    },
    // 提交数据之后的返回处理
    // todo 正式接入后注意修改重定向地址
    submitResult(val) {
      this.submitLoading = false
      if (val.resultCode === '0') {
        Cookies.set("SSO_TOKEN", val.data.token, { domain: ".sgsonline.com.cn", expires: 7 });
        this.dialogCode.visible = false
        setTimeout(() => { this.submitBtnLoading = false }, 1000)
        this.$message.success('提交成功')
        this.$emit('successCallback', val)
      } else if (val.resultCode === '9978') {
        Cookies.remove('SSO_TOKEN', { domain: '.sgsonline.com.cn' })
        this.dialogCode.visible = true
        this.submitBtnLoading = false
      } else if (val.resultCode === '1202') {
        this.$message.closeAll()
        // Cookies.remove('SSO_TOKEN', { domain: '.sgsonline.com.cn' })
        // this.dialogCode.visible = true
        // this.submitBtnLoading = false
      } else {
        this.$message.error(val.resultMsg)
        this.submitBtnLoading = false
      }
    },
    // 关闭发送验证码弹窗
    handleCloseSendCode() {
      // clearInterval(this.dialogCode.timer)
      // this.dialogCode.timer = null
      this.dialogCode.visible = false
    },
    // 关闭注册协议
    setTipsVisible(val) {
      this.dialogReg.visible = val;
    },
    // 文件上传前的钩子
    uploadBefore(file) {
      const imgSize = file.size / 1024 / 1024 < 20;
      if (!imgSize) {
        this.$message.error('上传文件不能超过20MB!');
      }
      return imgSize;
    },
    // 文件上传成功
    uploadSuccess(response, file, fileList) {
      this.formatFileList(fileList)
    },
    // 文件删除
    uploadRemove(response, fileList,) {
      this.formatFileList(fileList)
    },
    // 处理文件列表
    formatFileList(fileList) {
      this.form.files = []
      if (fileList.length) {
        fileList.forEach((v) => {
          if (v.response.resultCode === '0') this.form.files.push(v.response.data.fileName)
        })
      }
      this.$emit('emitHeightToParent', fileList)
    },
  }
}
</script>

<style lang="scss">
.quote {
  background: #fff;
  border-radius: 12px;

  &.wrap {
    display: block;
    width: 900px;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px 0;

    h2 {
      font-size: 22px;
      font-weight: normal;
    }

    span {
      color: #ca4300;
      font-size: 14px;
      padding-top: 15px;
    }
  }

  .form {
    padding: 0 80px;
    box-sizing: border-box;
    position: relative;

    .content {
      .el-form-item__content {
        width: 610px;
      }
    }

    .quick {
      position: absolute;
      right: 15px;
      top: 0;
    }

    .tips {
      color: #FF6600;
      font-size: 12px;
      padding: 0;
      margin: 0;
      height: 20px;
      line-height: 20px;
    }
  }

  .upload-demo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    .el-upload__tip {
      margin-left: 16px;
    }

    .el-upload-list {
      width: 610px;
    }
  }

  .submit {
    text-align: center;
    margin-bottom: 30px;

    button {
      width: 200px;
    }
  }

  .dialog {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 1;

    .content {
      position: relative;
      z-index: 2;
      left: 50%;
      top: 50%;
      margin-left: -335px;
      margin-top: -240px;
      width: 670px;
      height: 480px;

      .bg {
        width: 670px;
        height: 480px;
      }

      .close {
        position: absolute;
        top: 50px;
        right: 50px;
        cursor: pointer;
      }

      .btn {
        position: absolute;
        bottom: 65px;
        left: 200px;
        width: 270px;
        height: 48px;
        line-height: 48px;
        border-radius: 5px;
        color: #fff;
        font-size: 18px;
        padding: 0;
      }
    }
  }

  .contact_approve {
    margin: 0 0 20px 0;
    display: flex;
    justify-content: center;

    a {
      color: #ca4300;

      &:hover {
        color: #f49000;
      }
    }
  }

  .el-form-item__content {
    width: 280px;
  }

  .el-select {
    width: 100%;
  }

  .el-input__inner,
  .el-textarea__inner {
    border: none;
    background: #F2F2F2;
  }

  .el-form-item__label {
    font-weight: normal;
  }

  .el-input {
    width: 240px;
  }
}
</style>
